// Maak collection cards volledig klikbaar
document.addEventListener('DOMContentLoaded', function() {
  // Selecteer alle card wrappers
  const cardWrappers = document.querySelectorAll('.collection-card-wrapper, .collection-list-wrapper .card-wrapper, .card-wrapper');
  
  cardWrappers.forEach(function(cardWrapper) {
    // Zoek de link binnen deze card
    const link = cardWrapper.querySelector('.card__heading a, .card__content a');
    
    if (link && link.href) {
      // Maak de hele card klikbaar
      cardWrapper.addEventListener('click', function(e) {
        // Voorkom dat de link zelf wordt dubbel geklikt
        if (e.target.tagName.toLowerCase() === 'a') {
          return;
        }
        
        // Navigeer naar de link URL
        window.location.href = link.href;
      });
      
      // Voeg cursor pointer toe
      cardWrapper.style.cursor = 'pointer';
      
      // Voeg aria-label toe voor toegankelijkheid
      if (!cardWrapper.getAttribute('aria-label')) {
        const linkText = link.textContent.trim();
        cardWrapper.setAttribute('aria-label', 'Navigate to ' + linkText);
        cardWrapper.setAttribute('role', 'button');
        cardWrapper.setAttribute('tabindex', '0');
      }
      
      // Keyboard support (Enter en Space)
      cardWrapper.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          window.location.href = link.href;
        }
      });
    }
  });
});
